/*
 * Copyright (c) 2021. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import { BasicMenuViewModel } from 'src/types/view-models/menu.view.model';
import { Select } from '@americanexpress/dls-react';

export default class MiniDropdown extends Component<BasicMenuViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <div style={this.props.style} className={this.props.className}>
                <Select
                    disabled={this.props.disabled || false}
                    onChange={this.props.onChange}
                    value={this.props.value}
                    fluid={this.props.fullWidth}
                    id={this.props.id}
                >
                    {this.props.children}
                </Select>
            </div>
        );
    }
}
